import { render, staticRenderFns } from "./BatchReturn.vue?vue&type=template&id=52688923&"
import script from "./BatchReturn.vue?vue&type=script&lang=js&"
export * from "./BatchReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52688923')) {
      api.createRecord('52688923', component.options)
    } else {
      api.reload('52688923', component.options)
    }
    module.hot.accept("./BatchReturn.vue?vue&type=template&id=52688923&", function () {
      api.rerender('52688923', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchReturn.vue"
export default component.exports